module.exports = __webpack_public_path__ + "img/18.0ba858b3.png";